import {
  buttonNameConstants,
  buttonTypeConstants,
  EMPTY_STRING,
  toolTipMessages,
} from "../../../../constants";
import { StockAuditItemsToolTip } from "../../../../shared/components";
import ConfirmationModal from "../../Items/ConfirmationModal/ConfirmationModal";

const MarkCategoryCompleteModal = (props) => {
  const {
    isZeroConfirmationModal,
    toggleZeroConfirmationModal,
    categoryRow,
    countedItems,
    handleZeroButtonClicksUpdateValues,
  } = props;
  const categoryName = `${categoryRow?.categoryName} (${categoryRow?.productTypeName})`;
  const totalItems = categoryRow?.totalItems || 0;

  const handleZeroCancelButtonClick = () => {
    toggleZeroConfirmationModal();
  };
  const handleZeroIgnoreButtonClick = () => {
    handleZeroButtonClicksUpdateValues(buttonNameConstants.IGNORE_ITEMS);
  };
  const handleZeroButtonClick = () => {
    handleZeroButtonClicksUpdateValues(buttonNameConstants.ZERO_ITEMS);
  };

  const getConfirmCategoryCompletionIncompleteHtmlTitle = () => (
    <h5 className="mt-2 ms-2">
      Confirm Category Audit Completion –{" "}
      <span className="text-danger">
        Uncounted <StockAuditItemsToolTip />
        Detected
      </span>
    </h5>
  );

  return (
    <ConfirmationModal
      size={"lg"}
      isHtmlMessage={true}
      message={EMPTY_STRING}
      isConfirmationModal={isZeroConfirmationModal}
      toggleConfirmationModal={toggleZeroConfirmationModal}
      title={getConfirmCategoryCompletionIncompleteHtmlTitle()}
      // Cancel Button
      isNoButton={true}
      noButtonText={buttonNameConstants.CANCEL}
      handleNoButtonClick={handleZeroCancelButtonClick}
      // Ignore Items Button
      isDiscardButton={true}
      discardButtonText={buttonNameConstants.IGNORE_ITEMS}
      handleDiscardButtonClick={handleZeroIgnoreButtonClick}
      discardButtonToolTipBody={toolTipMessages.STOCK_AUDIT_ITEMS}
      // Zero Items Button
      handleYesButtonClick={handleZeroButtonClick}
      yesButtonText={buttonNameConstants.ZERO_ITEMS}
      yesButtonType={buttonTypeConstants.RED_BUTTON_FILL}
      yesButtonToolTipBody={toolTipMessages.STOCK_AUDIT_ITEMS}
    >
      <>
        <div className="mark-category-complete-modal">
          <div>
            Category Name: <span>{categoryName}</span>
          </div>
          <div>
            <StockAuditItemsToolTip text={"Total Items:"} />
            <span> ${totalItems}</span>
          </div>
          <div>
            <StockAuditItemsToolTip text={"Counted Items:"} />
            <span> ${countedItems || 0}</span>
          </div>
          <div>
            <StockAuditItemsToolTip text={"Uncounted Items:"} />
            <span className="uncounted-items">
              {" "}
              ${totalItems - countedItems}
            </span>
          </div>
        </div>
        <div className="pt-3">
          <p>
            It looks like there are some
            <StockAuditItemsToolTip className={"fw-bold"} />
            in this category that <strong>were not counted</strong> during this
            audit.
          </p>

          <p>
            Before you can mark this Category as <strong>Complete</strong>,
            please choose how you want to handle these{" "}
            <StockAuditItemsToolTip text={"items."} />
            This choice will affect how inventory is updated when the overall{" "}
            <strong>Audit Session</strong> is completed.
          </p>

          <p>
            Option 1: <strong>Ignore</strong> all uncounted
            <StockAuditItemsToolTip text={"items."} />
          </p>
          <ul>
            <li>
              The <strong>Counted Qty</strong> for each uncounted item will be
              set to the same value as its Expected Qty.
            </li>
            <li>
              Upon completion of the <strong>Audit Session</strong>, Inventory
              quantities for uncounted
              <StockAuditItemsToolTip />
              will remain as they were before the audit.
            </li>
          </ul>

          <p>
            Option 2: Set uncounted <StockAuditItemsToolTip />
            to <strong>Zero</strong>.
          </p>
          <ul>
            <li>
              The <strong>Counted Qty</strong> for each uncounted item will be
              set to 0.
            </li>
            <li>
              Upon completion of the <strong>Audit Session</strong>, Inventory
              quantities for uncounted <StockAuditItemsToolTip /> will be set to
              0.
            </li>
          </ul>
        </div>
      </>
    </ConfirmationModal>
  );
};

export default MarkCategoryCompleteModal;
